"use client";
import React from "react";
import type { GiroPreset } from "@/constants/giro-presets";

export type MultiGiroState = {
  giro: GiroPreset;
  setGiro: (g: GiroPreset) => void;
};

const MultiGiroContext = React.createContext<MultiGiroState | null>(null);

export function useMultiGiro() {
  const ctx = React.useContext(MultiGiroContext);
  if (!ctx) throw new Error("useMultiGiro must be used within MultiGiroProvider");
  return ctx;
}
export default MultiGiroContext;
